<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 14 14">
    <g transform="translate(-1055 -418)">
      <path d="M13.624,11.057,8.9,2.883a1.785,1.785,0,0,0-2.392-.642,1.688,1.688,0,0,0-.642.642L1.141,11.057a1.789,1.789,0,0,0,.642,2.394,1.645,1.645,0,0,0,.875.234h9.392a1.756,1.756,0,0,0,1.75-1.752A1.4,1.4,0,0,0,13.624,11.057Zm-6.242.292a.584.584,0,1,1,.583-.584A.551.551,0,0,1,7.383,11.349ZM7.966,8.43a.583.583,0,1,1-1.167,0V6.095a.583.583,0,1,1,1.167,0Z" transform="translate(1054.665 417.148)" fill="#ffd736" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconGear',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>